"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = SbInstallerPage;
const react_1 = __importStar(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const react_router_dom_1 = require("react-router-dom");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const MainSetupReact_1 = __importDefault(require("../React/MainSetupReact"));
const CommonComponents_1 = require("../View/Resultsets/CommonComponents");
const SbHowItWorks_1 = __importDefault(require("./SbHowItWorks"));
const SbInstallerComic_1 = __importDefault(require("./SbInstallerComic"));
const sbAccessApi_1 = require("./sbAccessApi");
const sbAccessView_1 = require("./sbAccessView");
/**
 * Punkt wydawania instalatora firmowego Second Brain (decyzja D-7 packa SB).
 *
 * Po co ta strona istnieje: do tej pory, żeby zainstalować Second Brain, trzeba było już mieć
 * dostęp do firmowego Dysku - czyli do tego samego, który instalator dopiero konfiguruje.
 * PS ENVI jest systemem, który nowa osoba ma pierwszego dnia, więc paczka wychodzi stąd.
 *
 * Pobranie to **zwykły odnośnik**, a nie fetch z obsługą błędu: trasa serwera odpowiada
 * `Content-Disposition: attachment`, więc przeglądarka zapisuje plik sama, a osoba bez sesji
 * dostaje z serwera odmowę zamiast pliku. O dostępie decyduje rejestr SB w PS.
 */
const PACKAGE_URL = `${MainSetupReact_1.default.serverUrl}sbInstaller/paczka`;
/** Wersja paczki zapisana w PS. Brak wartości albo błąd sieci = nic nie pokazujemy, bez komunikatu. */
async function fetchPackageVersion() {
    try {
        const response = await fetch(`${MainSetupReact_1.default.serverUrl}sbInstaller/info`, { credentials: "include" });
        if (!response.ok)
            return null;
        const data = await response.json();
        return typeof data?.version === "string" ? data.version : null;
    }
    catch {
        return null;
    }
}
/**
 * Kotwica sekcji "Po instalacji". Router jest hashowy (`#/sbInstaller`), więc drugi `#` w adresie
 * nie zadziała - instalator otwiera `/#/sbInstaller?sekcja=po-instalacji`, a strona sama przewija.
 */
const POST_INSTALL_ID = "po-instalacji";
/** `?widok=jak-to-dziala` otwiera od razu drugą zakładkę (np. link wysłany pracownikowi). */
const HOW_IT_WORKS = "jak-to-dziala";
/** Link zewnętrzny w nowej karcie - osoba ma wrócić na tę stronę, a nie jej szukać. */
function Link({ href, children }) {
    return (react_1.default.createElement("a", { href: href, target: "_blank", rel: "noopener noreferrer" }, children));
}
function SbInstallerPage() {
    const sb = (0, sbAccessApi_1.useSbAccess)();
    const [searchParams] = (0, react_router_dom_1.useSearchParams)();
    const login = (0, sbAccessView_1.parseGithubLoginParam)(searchParams.get("githubLogin"));
    const [linking, setLinking] = (0, react_1.useState)(false);
    const [linkResult, setLinkResult] = (0, react_1.useState)(null);
    const systemEmail = MainSetupReact_1.default.currentUserOrNull?.systemEmail?.trim();
    const loginAddress = systemEmail ? react_1.default.createElement("strong", null, systemEmail) : "adres, którym logujesz się do PS";
    const [tab, setTab] = (0, react_1.useState)(searchParams.get("widok") === HOW_IT_WORKS ? HOW_IT_WORKS : "instalator");
    const [scrollTarget, setScrollTarget] = (0, react_1.useState)(searchParams.get("sekcja"));
    const [packageVersion, setPackageVersion] = (0, react_1.useState)(null);
    (0, react_1.useEffect)(() => {
        document.title = "SB.ENVI - instalator";
    }, []);
    // Wersję pytamy tylko osób z dostępem - bez dostępu strona pokazuje samą odmowę.
    (0, react_1.useEffect)(() => {
        if (sb.state !== "granted")
            return;
        let active = true;
        fetchPackageVersion().then(version => { if (active)
            setPackageVersion(version); });
        return () => { active = false; };
    }, [sb.state]);
    // Sekcja pojawia się dopiero po sprawdzeniu dostępu, dlatego przewijamy po zmianie stanu.
    // Zakładka montuje treść dopiero po wybraniu, więc przewijamy także po przełączeniu zakładki.
    (0, react_1.useEffect)(() => {
        if (sb.state !== "granted" || tab !== "instalator" || scrollTarget !== POST_INSTALL_ID)
            return;
        document.getElementById(POST_INSTALL_ID)?.scrollIntoView?.();
        setScrollTarget(null);
    }, [sb.state, tab, scrollTarget]);
    function showPostInstall() {
        setTab("instalator");
        setScrollTarget(POST_INSTALL_ID);
    }
    async function linkAccount() {
        if (!login || linking)
            return;
        setLinking(true);
        setLinkResult(null);
        const result = await (0, sbAccessApi_1.linkOwnGithubAccount)(login);
        setLinking(false);
        if (result.ok) {
            setLinkResult({ login, success: true, message: `Gotowe - konto GitHub ${login} jest powiązane z Twoim dostępem.`, note: result.result === "PARTIAL" ? result.note : "" });
            sb.reload();
        }
        else {
            setLinkResult({ login, success: false, message: (0, sbAccessView_1.describeLinkFailure)(result.status, result.message), note: "" });
        }
    }
    if (sb.state === "loading")
        return react_1.default.createElement(CommonComponents_1.SpinnerBootstrap, null);
    if (sb.state === "error")
        return react_1.default.createElement(react_bootstrap_1.Container, { className: "py-4" },
            react_1.default.createElement(react_bootstrap_1.Alert, { variant: "danger" }, "Nie uda\u0142o si\u0119 sprawdzi\u0107 dost\u0119pu do Second Brain. Od\u015Bwie\u017C stron\u0119."));
    if (sb.state === "denied" || !sb.access?.sb)
        return (react_1.default.createElement(react_bootstrap_1.Container, { className: "py-4", style: { maxWidth: 760 } },
            react_1.default.createElement("h4", null, "Second Brain ENVI"),
            react_1.default.createElement(react_bootstrap_1.Alert, { variant: "info" }, "Nie masz jeszcze dost\u0119pu do Second Brain - popro\u015B prze\u0142o\u017Conego o zaproszenie do SB w PS.")));
    const access = sb.access.sb;
    const panelMode = (0, sbAccessView_1.linkPanelMode)(access, login);
    const result = linkResult?.login === login ? linkResult : null;
    return (react_1.default.createElement(react_bootstrap_1.Container, { className: "py-4", style: { maxWidth: 760 } },
        react_1.default.createElement("h4", null, "Second Brain ENVI"),
        react_1.default.createElement("p", { className: "text-muted" }, "Second Brain to wsp\u00F3lna baza wiedzy firmy. Na Twoim komputerze wida\u0107 j\u0105 jako zwyk\u0142y folder z notatkami, kt\u00F3ry sam od\u015Bwie\u017Ca si\u0119 w tle. Instalacja to oko\u0142o 15 minut i jeden plik - nie musisz zna\u0107 si\u0119 na niczym technicznym."),
        react_1.default.createElement(react_bootstrap_1.Card, { className: "mb-4" },
            react_1.default.createElement(react_bootstrap_1.Card.Body, null,
                react_1.default.createElement(react_bootstrap_1.Card.Title, null, "Tw\u00F3j dost\u0119p")),
            react_1.default.createElement(react_bootstrap_1.ListGroup, { variant: "flush" },
                react_1.default.createElement(react_bootstrap_1.ListGroup.Item, null,
                    react_1.default.createElement("strong", { className: "me-2" }, "GitHub"),
                    access.isGrantedManually ? react_1.default.createElement(react_bootstrap_1.Badge, { bg: "success" }, "Aktywny (nadany r\u0119cznie)") : (access.githubState === "PENDING" ? react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(react_bootstrap_1.Badge, { bg: "warning", text: "dark" }, "Zaproszenie czeka na przyj\u0119cie"),
                        react_1.default.createElement("div", { className: "text-muted mt-1" }, "Sprawd\u017A poczt\u0119 (adres logowania do PS) i kliknij Join, potem Continue with Google.")) : access.githubState === "LINKED" ? react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(react_bootstrap_1.Badge, { bg: "success" }, "Aktywny"),
                        react_1.default.createElement("div", { className: "text-muted mt-1" },
                            "Konto: ",
                            access.githubLogin)) : react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(react_bootstrap_1.Badge, { bg: "secondary" }, "Aktywny, konto niepowi\u0105zane"),
                        react_1.default.createElement("div", { className: "text-muted mt-1" }, "Konto GitHub powi\u0105\u017Ce si\u0119 po pierwszym uruchomieniu instalatora.")))),
                react_1.default.createElement(react_bootstrap_1.ListGroup.Item, null,
                    react_1.default.createElement("strong", { className: "me-2" }, "Dysk Google"),
                    access.driveState === "READY" ? react_1.default.createElement(react_bootstrap_1.Badge, { bg: "success" }, "Gotowy") : react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(react_bootstrap_1.Badge, { bg: "danger" }, "Brak dost\u0119pu do Dysku"),
                        react_1.default.createElement("div", { className: "text-muted mt-1" }, "Popro\u015B prze\u0142o\u017Conego o sprawdzenie dost\u0119pu do SB w PS."))))),
        result && react_1.default.createElement(react_bootstrap_1.Alert, { variant: result.success ? "success" : "danger" }, result.message),
        result?.note && react_1.default.createElement(react_bootstrap_1.Alert, { variant: "warning" }, result.note),
        panelMode === "ask" && !result?.success && react_1.default.createElement(react_bootstrap_1.Alert, { variant: "light", className: "border" },
            react_1.default.createElement("p", null,
                "Instalator wykry\u0142 na tym komputerze konto GitHub: ",
                react_1.default.createElement("strong", null, login),
                ". Czy to Twoje konto?"),
            react_1.default.createElement(react_bootstrap_1.Button, { variant: "primary", disabled: linking, onClick: linkAccount },
                linking && react_1.default.createElement(react_bootstrap_1.Spinner, { animation: "border", size: "sm", className: "me-2", "aria-label": "Trwa powi\u0105zanie konta" }),
                "To moje konto")),
        panelMode === "already" && !result?.success && react_1.default.createElement(react_bootstrap_1.Alert, { variant: "success" },
            "Konto GitHub ",
            login,
            " jest ju\u017C powi\u0105zane z Twoim dost\u0119pem."),
        panelMode === "other" && react_1.default.createElement(react_bootstrap_1.Alert, { variant: "warning" },
            "Masz ju\u017C powi\u0105zane konto GitHub ",
            access.githubLogin,
            ", a instalator wykry\u0142 ",
            login,
            ". Zmian\u0119 konta zle\u0107 prze\u0142o\u017Conemu."),
        react_1.default.createElement(react_bootstrap_1.Tabs, { activeKey: tab, onSelect: key => setTab(key ?? "instalator"), mountOnEnter: true, unmountOnExit: true, className: "mb-4" },
            react_1.default.createElement(react_bootstrap_1.Tab, { eventKey: "instalator", title: "Instalator" },
                react_1.default.createElement(react_bootstrap_1.Card, { className: "mb-4" },
                    react_1.default.createElement(react_bootstrap_1.Card.Body, { className: "d-flex flex-wrap align-items-center justify-content-between gap-3" },
                        react_1.default.createElement("div", null,
                            react_1.default.createElement(react_bootstrap_1.Card.Title, { className: "mb-1" }, "Instalator"),
                            react_1.default.createElement(react_bootstrap_1.Card.Text, { className: "text-muted mb-0" }, "Pobierzesz plik ZIP. Co z nim zrobi\u0107, pokazuj\u0105 rysunki ni\u017Cej."),
                            packageVersion && react_1.default.createElement("div", { className: "small text-muted mt-1" },
                                "Wersja dost\u0119pna w PS: ",
                                packageVersion)),
                        react_1.default.createElement(react_bootstrap_1.Button, { href: PACKAGE_URL, variant: "primary", size: "lg" },
                            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faDownload, className: "me-2" }),
                            "Pobierz instalator"))),
                react_1.default.createElement("h5", null, "Instalacja krok po kroku"),
                react_1.default.createElement(SbInstallerComic_1.default, { loginAddress: loginAddress }),
                react_1.default.createElement(react_bootstrap_1.Alert, { variant: "light", className: "border" },
                    "Konto GitHub zak\u0142adasz przez ",
                    react_1.default.createElement("em", null, "Continue with Google"),
                    ". Je\u015Bli na stronie logowania nie ma przycisku Google, wejd\u017A przez",
                    " ",
                    react_1.default.createElement(Link, { href: "https://github.com/signup" }, "github.com/signup"),
                    " i tam wybierz",
                    " ",
                    react_1.default.createElement("em", null, "Continue with Google"),
                    ". Komunikat ",
                    react_1.default.createElement("em", null, "Too many requests"),
                    " mija sam po kilku minutach - poczekaj i spr\u00F3buj ponownie."),
                react_1.default.createElement(react_bootstrap_1.Alert, { variant: "light", className: "border" }, "Instalator mo\u017Cna uruchamia\u0107 wielokrotnie - je\u015Bli przerwiesz go w po\u0142owie albo kt\u00F3ry\u015B krok wy\u017Cej zrobisz p\u00F3\u017Aniej, po prostu odpal go jeszcze raz. Nic nie nadpisze i nic nie zepsuje. Gdyby co\u015B wygl\u0105da\u0142o na zawieszone, zwykle brakuje przyj\u0119tego zaproszenia na GitHubie (sprawd\u017A poczt\u0119 na adres logowania do PS) albo jeste\u015B zalogowany do Dysku Google innym kontem ni\u017C to z PS."),
                react_1.default.createElement(react_bootstrap_1.Alert, { variant: "light", className: "border" },
                    "Je\u015Bli poprosimy Ci\u0119 o zapis przebiegu instalacji: to plik ",
                    react_1.default.createElement("code", null, "bootstrap.log"),
                    " w folderze ",
                    react_1.default.createElement("code", null, "%USERPROFILE%\\.envi\\instalator"),
                    " (wklej t\u0119 \u015Bcie\u017Ck\u0119 w pasek adresu Eksploratora). Instalator podaje pe\u0142n\u0105 \u015Bcie\u017Ck\u0119 na ko\u0144cu ka\u017Cdego przebiegu."),
                react_1.default.createElement("h5", { id: POST_INSTALL_ID, className: "mt-4" }, "Po instalacji - co dalej"),
                react_1.default.createElement("p", null,
                    "Jak p\u0142ynie wiedza i z czego korzysta agent, pokazuje zak\u0142adka",
                    " ",
                    react_1.default.createElement(react_bootstrap_1.Button, { variant: "link", className: "p-0 align-baseline", onClick: () => setTab(HOW_IT_WORKS) }, "Jak to dzia\u0142a"),
                    "."),
                react_1.default.createElement(react_bootstrap_1.ListGroup, { numbered: true, className: "mb-4" },
                    react_1.default.createElement(react_bootstrap_1.ListGroup.Item, null,
                        react_1.default.createElement("strong", null, "Ikony na pulpicie."),
                        " Instalator umieszcza na pulpicie ikony ",
                        react_1.default.createElement("em", null, "Claude"),
                        ",",
                        " ",
                        react_1.default.createElement("em", null, "Codex (ChatGPT)"),
                        " i ",
                        react_1.default.createElement("em", null, "Aktualizuj Second Brain"),
                        ". Chcesz je mie\u0107 na pasku zada\u0144? Kliknij ikon\u0119 prawym przyciskiem i wybierz ",
                        react_1.default.createElement("em", null, "Przypnij do paska zada\u0144"),
                        " (je\u015Bli jej nie wida\u0107, najpierw ",
                        react_1.default.createElement("em", null, "Poka\u017C wi\u0119cej opcji"),
                        ") - Windows 11 nie pozwala programom robi\u0107 tego samodzielnie."),
                    react_1.default.createElement(react_bootstrap_1.ListGroup.Item, null,
                        react_1.default.createElement("strong", null, "Claude."),
                        " Instalator stawia aplikacj\u0119 Claude sam. Uruchom j\u0105 ikon\u0105 na pulpicie albo z menu Start, przejd\u017A do zak\u0142adki ",
                        react_1.default.createElement("em", null, "Code"),
                        " i wska\u017C folder ",
                        react_1.default.createElement("code", null, "ENVI-Kanon"),
                        " (w Twoim folderze u\u017Cytkownika). Kto woli terminal: w tym folderze wpisz ",
                        react_1.default.createElement("code", null, "claude"),
                        "."),
                    react_1.default.createElement(react_bootstrap_1.ListGroup.Item, null,
                        react_1.default.createElement("strong", null, "Codex."),
                        " Instalator stawia te\u017C aplikacj\u0119 Codex (w menu Start nazywa si\u0119 ChatGPT). Uruchom j\u0105 i wska\u017C ten sam folder ",
                        react_1.default.createElement("code", null, "ENVI-Kanon"),
                        ". W terminalu:",
                        " ",
                        react_1.default.createElement("code", null, "codex"),
                        "."),
                    react_1.default.createElement(react_bootstrap_1.ListGroup.Item, null,
                        react_1.default.createElement("strong", null, "Pierwsze logowanie."),
                        " Obie aplikacje poprosz\u0105 o zalogowanie. Claude i Codex wymagaj\u0105 p\u0142atnego konta; z kt\u00F3rego konta korzysta\u0107, wska\u017Ce prze\u0142o\u017Cony."),
                    react_1.default.createElement(react_bootstrap_1.ListGroup.Item, null,
                        react_1.default.createElement("strong", null, "Umiej\u0119tno\u015Bci (skille)."),
                        " S\u0105 ju\u017C na miejscu, nic nie instalujesz."),
                    react_1.default.createElement(react_bootstrap_1.ListGroup.Item, null,
                        react_1.default.createElement("strong", null, "Dysk i Dokumenty Google."),
                        " Dzia\u0142aj\u0105 po jednorazowym logowaniu do Google, kt\u00F3re instalator prowadzi w trakcie przebiegu."),
                    react_1.default.createElement(react_bootstrap_1.ListGroup.Item, null,
                        react_1.default.createElement("strong", null, "Aktualizacje."),
                        " Gdy przy zegarze pojawi si\u0119 dymek \u201ESecond Brain: jest nowa wersja\", kliknij go albo ikon\u0119 ",
                        react_1.default.createElement("em", null, "Aktualizuj Second Brain"),
                        " na pulpicie (jest te\u017C w menu Start). ZIP-a nie pobierasz drugi raz. Aktualizacja od\u015Bwie\u017Ca te\u017C Pythona, Node.js, Git oraz Claude i Codex w terminalu, a aplikacje Claude i Codex aktualizuj\u0105 si\u0119 same. Nic nie nadpisze i nic nie zepsuje."),
                    react_1.default.createElement(react_bootstrap_1.ListGroup.Item, null,
                        react_1.default.createElement("strong", null, "Gdy co\u015B si\u0119 nie uda\u0142o."),
                        " Wy\u015Blij plik ",
                        react_1.default.createElement("code", null, "bootstrap.log"),
                        " z folderu",
                        " ",
                        react_1.default.createElement("code", null, "%USERPROFILE%\\.envi\\instalator"),
                        " (wklej t\u0119 \u015Bcie\u017Ck\u0119 w pasek adresu Eksploratora)."))),
            react_1.default.createElement(react_bootstrap_1.Tab, { eventKey: HOW_IT_WORKS, title: "Jak to dzia\u0142a" },
                react_1.default.createElement(SbHowItWorks_1.default, { onShowPostInstall: showPostInstall })))));
}
